<div class="panel panel-font gradient-bg">
  <span class="panel-title"> {{ 'Vyhledání jedoucího spoje' | translate}}</span>
  <a [routerLink]="'/'" class="closeBtn" title="{{ 'zavřít' | translate }}"></a>
  <app-search-input [inputData]="state.searchText" [placeholder]="'Název spoje...'" (search)="onSearch($event)" />

  <div *ngIf="loading">
    <app-loading></app-loading>
  </div>

  <div *ngIf="state.searchedConnections.length > 0 && !loading">
    <ul class="mainList">
      <li *ngFor="let conn of state.searchedConnections" [routerLink]="['/detail', conn.id]"
          tabindex="0" (mouseenter)="startHover(conn.id)" (mouseleave)="endHover(conn.id)">
        <app-connection [connection]="conn" />
      </li>
    </ul>
  </div>

  <div class="panel-subtitle mt4" *ngIf="state.searchedConnections.length == 0 && term && !loading">
    {{ 'Nebyl nalezen žádný spoj s tímto názvem.' | translate }}
  </div>
</div>
